/** Estado de la entrega según vencimiento (calculado). */
export type EstadoEntregaEPP =
  | 'vigente'
  | 'por_vencer'
  | 'vencido'
  | 'devuelto';

export interface AreaEPP {
  id: string;
  nombre: string;
}

export interface TrabajadorEPP {
  id: string;
  nombre: string;
  areaId: string;
}

export interface EntregaEPP {
  id: string;
  trabajadorId: string;
  tipoEPP: string;
  fechaEntrega: string;
  fechaVencimiento: string;
  cantidad: number;
  observaciones: string;
  devuelto: boolean;
  fechaDevolucion: string;
  createdAt: string;
  updatedAt: string;
}

export const ESTADO_ENTREGA_LABEL: Record<EstadoEntregaEPP, string> = {
  vigente: 'Vigente',
  por_vencer: 'Por vencer',
  vencido: 'Vencido',
  devuelto: 'Devuelto',
};

/** Días antes del vencimiento para considerar "por_vencer". */
export const DIAS_ALERTA_VENCIMIENTO = 30;

/** Calcula el estado de la entrega según fecha de vencimiento y si fue devuelto. */
export function getEstadoEntrega(item: EntregaEPP): EstadoEntregaEPP {
  if (item.devuelto) return 'devuelto';
  const hoy = new Date();
  hoy.setHours(0, 0, 0, 0);
  const venc = new Date(item.fechaVencimiento);
  venc.setHours(0, 0, 0, 0);
  const diffDays = Math.ceil((venc.getTime() - hoy.getTime()) / (24 * 3600 * 1000));
  if (diffDays < 0) return 'vencido';
  if (diffDays <= DIAS_ALERTA_VENCIMIENTO) return 'por_vencer';
  return 'vigente';
}
